import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import booleanContains from '@turf/boolean-contains';
import { convertPointToGEOJSONFormat, createFeatureConfig, createGeometryConfig } from './mapUtils';

export const getCurrentPlace = (order, places) => {
  const placeId = get(order, 'delivery_place_id');
  return find(places, ({id}) => id === placeId);
}

export const getDropoffLocations = (order, places) => {
  const currentPlace = getCurrentPlace(order, places)
  return get(currentPlace, 'dropoff_locations', []);
}

export const getCurrentDropoff = (order, places) => {
  const dropoffId = get(order, 'dropoff_location_id');
  const dropoffLocations = getDropoffLocations(order, places)
  const dropoff = find(dropoffLocations, ({id}) => id === dropoffId);
  return dropoff ? {value: dropoff.id, label: dropoff.name} : undefined;
}

export const getDefaultDropoff = (order, places) => {
  const dropoffId = get(order, 'dropoff_location_id');
  const dropoffLocations = getDropoffLocations(order, places)
  const selection = find(dropoffLocations, ({id}) => id === dropoffId);
  const first = dropoffLocations[0];
  const loc = selection ? selection : first;
  return loc ? {value: loc.id, label: loc.name} : undefined;
}

// Determine if the given address is within the kitchen's pickup polygon
export const isWithinPickupPolygon = (addrInfo, kitchen) => {
  const pickupEnabled = get(kitchen, 'pickup_enabled', false);
  const addrLocation = get(addrInfo, 'location', null);
  const pickupPolygon = get(kitchen, 'pickup_details.polygon', null);

  if (!pickupEnabled || isEmpty(pickupPolygon) || isEmpty(addrLocation)) {
    return false;
  }

  const locationFeature = createFeatureConfig(
    createGeometryConfig('Point',
      convertPointToGEOJSONFormat([addrInfo.location])
    )
  );
  const pickupPolygonFeature = createFeatureConfig(pickupPolygon);

  return booleanContains(pickupPolygonFeature, locationFeature);
};
